import {NodeType} from "./CategoryTree";
import {Button, Tooltip} from "antd";
import {PlusOutlined, FolderOutlined, FolderAddOutlined} from "@ant-design/icons";
import {ALL_NOTES, ROOT_LEVEL} from "../utils/constants";

const CategoryTreeHeader = ({
                                openCreateModal,
                                onClickOnHeaderNode,
                                isMoveCategoryModal = false,
                                selectedCategoryId,
                                isMoveNoteModal
                            }: {
    openCreateModal: () => void,
    onClickOnHeaderNode: (node: NodeType) => void,
    isMoveCategoryModal?: boolean,
    selectedCategoryId: number,
    isMoveNoteModal: boolean
}) => {

    return (
        <div className="space-y-4">
            {!isMoveCategoryModal && !isMoveNoteModal && (
                    <>
                        <div className="flex justify-between items-center">
                            <h2 className="text-lg font-semibold text-[#0b1d51] dark:text-white">Categories</h2>
                            <Tooltip title="Add new category" placement="right">
                                <Button
                                    onClick={() => openCreateModal()}
                                    type="default"
                                    icon={<FolderAddOutlined className="text-lg" />}
                                    className="!bg-[#048ba8]/10 hover:!bg-[#048ba8] !text-[#048ba8] hover:!text-white border-none shadow-none transition-all duration-200 flex items-center justify-center w-8 h-8 rounded-lg hover:scale-110"
                                    aria-label="Add new category"
                                />
                            </Tooltip>
                        </div>
                        <button
                            onClick={() => onClickOnHeaderNode(ALL_NOTES)}
                            className={`all-notes-button w-full text-left px-4 py-2 rounded-lg transition-colors duration-200 ${selectedCategoryId === ALL_NOTES.id ? 'bg-[#f4d35e] text-[#0b1d51] font-semibold' : 'hover:bg-[#f4d35e]/50'}`}
                        >
                            <span className="flex items-center gap-2">
                              <FolderOutlined className="text-[#048ba8]"/>
                              All Notes
                            </span>
                        </button>
                    </>
                )
            }
            <button
                onClick={() => onClickOnHeaderNode(ROOT_LEVEL)}
                style={{ margin: '2px' }}
                className={`w-full text-left px-4 py-2 rounded-lg transition-colors duration-200 ${selectedCategoryId === ROOT_LEVEL.id ? 'bg-[#f4d35e] text-[#0b1d51] font-semibold' : 'hover:bg-[#f4d35e]/50'}`}
            >
              <span className="flex items-center gap-2">
                <FolderOutlined className="text-[#048ba8]"/>
                Unassigned
              </span>
            </button>
        </div>
    );
};

export default CategoryTreeHeader;